import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';

import { setTargetRatesShowRecessions } from 'TargetRatesApp/apps/target-rates-app/state/show-recessions/show-recessions.actions';

import { StocksPageIndicesGetData } from 'CompanyApp/ts/interfaces/stocks-page-view-responses.interface';
import { TargetRatesRootStore } from 'TargetRatesApp/interfaces/state.interface';
import { IntradayRatesIndicesResponse } from 'TargetRatesApp/interfaces/target-rates-endpoints.interfaces';

import { UrlsService } from 'Angular/services/core/urls.service';
import { TargetRatesService } from 'TargetRatesApp/services/target-rates.service';

import { SimpleFundChartComponent } from 'ChartApp/ts/features/simple-fund-chart/simple-fund-chart.component';
import { formatChange } from 'Angular/utils/string-utils';

@Component({ standalone: false, selector: 'ycn-intradays-rates', templateUrl: './intradays-rates.template.html' })
export class IntradaysRatesComponent implements OnInit {
    @ViewChild(SimpleFundChartComponent) simpleFundChart!: SimpleFundChartComponent;

    chartCalcs: string[] = ['level'];

    indicesList: string[] = ['^FVX', '^TNX', '^TYX'];

    showRecessions: boolean = false;

    indices: StocksPageIndicesGetData[] = [];

    latestDate: string = '';

    constructor(
        private readonly store: Store<{ reducers: TargetRatesRootStore }>,
        private targetRatesService: TargetRatesService,
        private urlsService: UrlsService
    ) {}

    ngOnInit(): void {
        this.targetRatesService.getIntraDayRatesIndices().subscribe((response: IntradayRatesIndicesResponse) => {
            this.indices = response.indices_data;
            this.indicesList = response.indices_list;
            this.latestDate = response.latest_date;
            for (let i = 0; i < this.indices.length; i += 1) {
                const levelChange = this.indices[i].change;
                const percentChange = this.indices[i].change_percent;
                if (levelChange) {
                    this.indices[i].change = formatChange(levelChange);
                }
                if (percentChange) {
                    this.indices[i].change_percent = formatChange(percentChange);
                }
            }
        });
    }

    updateShowRecessesions(showRecessions: boolean): void {
        this.store.dispatch(setTargetRatesShowRecessions({ showRecessions }));
    }

    goToFundChartTab(): void {
        const queryParams = this.simpleFundChart.getQueryParams();
        window.location.href = `${this.urlsService.CHARTS.FUND_CHART_PAGE}#/?${queryParams}`;
    }
}
